<template>
    <div class="content-main">
        <div class="cont-top m-b-30 com-model flex flex-column align-initial flex-between">
            <div class="cont-title">招聘中</div>
            <el-tabs class="ac-tabs" v-model="acType" @tab-click="handleClick">
                <el-tab-pane label="网络招聘会" name='1'></el-tab-pane>
                <el-tab-pane label="线下招聘会" name="2"></el-tab-pane>
            </el-tabs>
        </div>
        <div style="margin-top: 4px">
            <div class="ac-cont com-model">
                <div style="margin-bottom: 60px">
                    <activity-item :item="item" v-for="item in typeList[acType].list" :key="item.id" />
                </div>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="typeList[acType].pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="typeList[acType].pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="typeList[acType].total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import ActivityItem from '../../components/ActivityItem.vue';
    import Pageing from '../../components/Pageing'
    export default {
        data(){
            return {
                typeList: {
                    1: {
                        pageNum: 1,
                        pageSize: 10,
                        list: [],
                        total: null
                    },
                    2: {
                        pageNum: 1,
                        pageSize: 10,
                        list: [],
                        total: null
                    }
                },
                acType: '1'
            }
        },
        components: {
            ztxPaging: Pageing,
            ActivityItem
        },
        watch:{
            pageNum(){
                this.getList();
            }
        },
        created(){
          this.getList();
        },
        methods:{
            handleClick(type){
                this.acType = type.name
                this.getList()
            },
            handleSizeChange (val){
                this.typeList[this.acType].pageSize = val
            },
            handleCurrentChange(val) {
                this.typeList[this.acType].pageNum = val;
                this.getList()
            },
            getList(){
                const data = this.typeList[this.acType];
                const pageNum = data.pageNum;
                const pageSize = data.pageSize
                this.axios.get('/wapi/activity/listAll?pageNum=' + pageNum + '&pageSize=' + pageSize+'&type='+ this.acType).then(res => {
                    this.typeList[this.acType].list = res.rows;
                    this.typeList[this.acType].total = res.total;
                })
            }
        }
    }
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
.cont-top {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
.ac-cont{
    padding: 24px;
    &.com-model {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// jobfair.vue?1852e716